import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { VehicleService } from "./vehicle.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { faStar, faPlus } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { AddVehiclesService } from "../add-vehicles/add-vehicles.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-vehicle",
  templateUrl: "./vehicle.component.html",
  styleUrls: ["./vehicle.component.sass"],
})
export class VehicleComponent implements OnInit {
  faPlus = faPlus;
  itemsPerPage = 5;

  page: number = 1;
  totalItems: any;
  allVehicleList: any;
  
  searchText: any;

  closeResult: string;
  vehicleName = "";
  vehicleType = "";
  vehicleImage = "";
  vehicleNumber = "";
  vehicleContactName = "";
  vehicleContactMobile = "";
  vehicleCity = "";
  vehicleState = "";
  cityLatitude = "";
  cityLongtitude = "";
  vehicleLength = "";
  vehicleBreadth = "";
  vehicleHeight = "";
  vehicleCapacity:Number;
  originalPrice = "";
  discountPrice = "";
  termsAndConditions = "";
  rating = "";
  labourAvailable = false;
  sharingMode = false;
  activeStatus = false;
  vehicleid = "";
  userId = "";
  searchBy = "";
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private vehicleService: VehicleService,
    private modalService: NgbModal,
    private addVehicleService: AddVehiclesService,
    private router: Router,
    private addvehicelService: AddVehiclesService
  ) {}

  ngOnInit(): void {
    this.getAllVehicle();
    this.getRange();
  }

  getAllVehicle() {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      isDeleted: 0,
    };
    this.vehicleService.getAllVehicle(data).subscribe((result: any) => {
      console.log("get all vehicles ", result);
      this.allVehicleList = result.data;
      this.totalItems = result.totalRecords;
      this.spinner.hide();
    });
  }

  gty(page: any) {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: this.page - 1,
      isDeleted: 0,
    };
    this.vehicleService.getAllVehicle(data).subscribe((result: any) => {
      console.log("vehicles", result);
      this.allVehicleList = result.data;
      this.totalItems = result.totalRecords;
      this.spinner.hide();
    });
  }

  // applyFilter(filterValue:any){
  //   console.log(filterValue);
  //   let filterValueLower = filterValue.toLowerCase();
  //        if(filterValue === '' ) {
  //            this.allVehicleList=this.allVehicleList_forFilter;
  //        }
  //        else {
  //          this.allVehicleList = this.allVehicleList_forFilter.filter((employee:any) => employee.vehicleName.toLowerCase().includes(filterValueLower))
  //         }
  // }

  search() {
    if (this.searchText != "") {
      let data = {
        fieldName: this.searchBy,
        searchText: this.searchText,
      };
      this.spinner.show();
      this.vehicleService.searchVehicle(data).subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.allVehicleList = result.data;
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
        console.log(result);
      });
    } else {
      this.toastr.error("Please Fill Search text");
    }
  }

  getActivationToggleData(event, data) {
    let sendData = {
      id: data._id,
      currentStatus: event == true ? 1 : 0,
    };
    console.log(sendData);
    this.spinner.show();
    this.vehicleService.updateVehicle(sendData).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success(result.message);
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  deleteVehicle(data) {
    let sendData = {
      id: data._id,
      isDeleted: 1,
    };
    console.log(sendData);
    this.spinner.show();
    this.vehicleService.updateVehicle(sendData).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success("Vehicle Deleted Successfully");
        this.getAllVehicle();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  editVehicle(content, data) {
    this.openAddVehicleModal(content);
    this.vehicleName = data.vehicleName;
    this.vehicleType = data.type;
    this.vehicleNumber = data.vehicleRegNo;
    this.vehicleContactName = data.vehicleContactName;
    this.vehicleContactMobile = data.vehicleContactNumber;
    this.vehicleCity = data.vehicleCity;
    this.vehicleState = data.vehicleState;
    this.cityLatitude = data.currentLatitude;
    this.cityLongtitude = data.currentLongitude;
    this.vehicleBreadth = data.vehicleBreadth;
    this.vehicleLength = data.vehicleLength;
    this.vehicleHeight = data.vehicleHeight;
    this.vehicleCapacity = data.vehicleCapacity;
    this.originalPrice = data.originalPrice;
    this.discountPrice = data.discountedPrice;
    this.termsAndConditions = data.termsCondition;
    this.rating = data.rating;
    this.vehicleid = data.vehicleId;
    this.userId = data._id;
    this.sharingMode = data.sharingMode;
    this.activeStatus = data.currentStatus;
    this.labourAvailable = data.labourAvailable;
    this.vehiclePrice = data.vehiclePrice;
    (this.vehicleImage = data.images), (this.imageUrl = data.images);
    (this.insuranceImageUrl = data.insuranceImage),
      (this.rcImageUrl = data.rcImage),
      (this.roadtaxImageUrl = data.roadtaxImage);
  }

  // Update Vehicle General InFo
  updateVehicle() {
    let data = {
      id: this.userId,
      vehicleName: this.vehicleName,
      type: this.vehicleType,
      labourAvailable: this.labourAvailable,
      originalPrice: this.originalPrice,
      discountedPrice: this.discountPrice,
      termsCondition: this.termsAndConditions,
      currentLatitude: this.cityLatitude,
      currentLongitude: this.cityLongtitude,
      currentStatus: this.activeStatus == true ? 1 : 0,
      rating: this.rating,
      sharingMode: this.sharingMode,
      vehicleContactNumber: this.vehicleContactMobile,
      vehicleContactName: this.vehicleContactName,
      vehicleCity: this.vehicleCity,
      vehicleState: this.vehicleState,
      vehicleRegNo: this.vehicleNumber,
      vehicleLength: this.vehicleLength,
      vehicleBreadth: this.vehicleBreadth,
      vehicleHeight: this.vehicleHeight,
      vehicleSizeDimention:this.vehicleLength+ " X " +this.vehicleBreadth+ " X " +this.vehicleHeight,
      vehicleCapacity: this.vehicleCapacity,
      images: this.imageUrl,
      roadtaxImage: this.roadtaxImageUrl,
      rcImage: this.rcImageUrl,
      insuranceImage: this.insuranceImageUrl,
    };
    this.spinner.show();
    this.vehicleService.updateVehicle(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success(result.message);
        this.getAllVehicle();
        this.modalService.dismissAll();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  // Update Range code Start
  // Update Range & Prices function
  updateRangePrice() {
    let data = {
      id: this.userId,
      vehiclePrice: this.vehiclePrice,
    };
    this.spinner.show();
    this.vehicleService.updateVehicle(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success(result.message);
        this.getAllVehicle();
        this.modalService.dismissAll();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  allRanges: any[] = [];
  // fun to get all Ranges
  getRange() {
    this.spinner.show();
    this.vehicleService.getAllRanges().subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        console.log("allRange", result);
        this.allRanges = result.data;
      } else this.toastr.error(result.message);
    });
  }
  selectedRange: any = ""; // Holds the currently selected range
  priceInput: number | null = null; // Holds user input for price
  discountedPriceInput: number | null = null; // Holds user input for discountedPrice
  vehiclePrice: {
    min: number;
    max: number;
    price: number;
    discountedPrice: number;
  }[] = [];
  message: string = ""; // Variable to store status or error messages
  messageType: string = ""; // Holds the type of message ('success' or 'error')

  onRangeChange() {
    this.priceInput = null;
    this.discountedPriceInput = null;
    this.message = "";
  }

  // function to add or update range and prices in:: vehiclePrice array
  updateVehiclePrice(index: number) {
    // Reset message and messageType
    this.message = "";
    this.messageType = "";

    // Initialize vehiclePrice if it is null or undefined
    if (!Array.isArray(this.vehiclePrice)) {
      this.vehiclePrice = []; // Initialize it to an empty array
    }

    // Check if allRanges is valid
    if (!Array.isArray(this.allRanges)) {
      this.message = "Error: allRanges is not a valid array.";
      this.messageType = "error";
      return;
    }

    // Get the corresponding range from allRanges
    const range = this.allRanges[index];

    // If the index is out of bounds, initialize a new range in vehiclePrice
    if (index < 0 || index >= this.vehiclePrice.length) {
      // Create a new entry with default values if index is invalid
      this.vehiclePrice[index] = {
        min: range?.min ?? 0,
        max: range?.max ?? 0,
        price: 0,
        discountedPrice: 0,
      };
    }

    // Validate the range
    if (!range || range.min === undefined || range.max === undefined) {
      this.message = `Error: Please fill all fields before adding. `;
      this.messageType = "error";
      return; // Exit if invalid range found
    }

    // Update min and max values for the selected index
    this.vehiclePrice[index].min = range.min;
    this.vehiclePrice[index].max = range.max;

    // Validate price inputs
    if (this.priceInput == null || this.discountedPriceInput == null) {
      this.message = "Error: Price and discounted price must be provided.";
      this.messageType = "error";
      return; // Exit if prices are not provided
    }

    // Check if discounted price is less than price
    if (this.discountedPriceInput >= this.priceInput) {
      this.message = "Error: Discounted price must be less than the price.";
      this.messageType = "error";
      return; // Exit iif discounted price is invalid
    }

    // Set the price and discounted price for the selected index
    this.vehiclePrice[index].price = this.priceInput;
    this.vehiclePrice[index].discountedPrice = this.discountedPriceInput;

    // Success message
    this.message = `Vehicle prices updated successfully for range (${range.min} - ${range.max} KM).`;
    this.messageType = "success";

    // Optional: Sort the vehiclePrice array by min value after updating
    this.vehiclePrice.sort((a, b) => a.min - b.min);

    console.log("Updated vehicle price list:", this.vehiclePrice);
  }

  // Imp:: Check All Ranges are in Sync in vehiclePrice array 
  checkMinMaxSync() {
    // Check if there are any issues with the min/max sync
    const errorMsg = this.checkMinValue();
    
    // If there's an error message, log the error and return
    if (errorMsg) {
        console.log(errorMsg); // Log the specific error message
        // Optionally, set the error message to display in the UI
        this.message = errorMsg;
        this.messageType = 'error';
        return; // Exit if the check fails
    } 
    
    // If no errors, proceed with the update
    this.updateRangePrice();
    console.log("Range is in Sync");
    
    // Optionally, set success message
    this.message = 'Range is in Sync.';
    this.messageType = 'success';
}


  checkMinValue(): string | null {
    // Ensure vehiclePrice has at least 2 entries
    if (this.vehiclePrice.length < 2) {
        return null; // No need to check if there's not enough data
    }

    // Iterate through the vehiclePrice array starting from the second index
    for (let i = 1; i < this.vehiclePrice.length; i++) {
        const minCurrent = this.vehiclePrice[i]?.min;
        const maxPrevious = this.vehiclePrice[i - 1]?.max;

        // Check if the current min is exactly equal to the previous max + 1
        if (minCurrent !== undefined && maxPrevious !== undefined) {
            if (minCurrent !== maxPrevious + 1) {
                // Return error with row numbers where the issue occurred
                return `Error: Range is not in sync between rows ${i} and ${i + 1}.`;
            }
        } else {
            // Return error if min or max values are missing
            return `Error: Missing min or max values in row ${i + 1}.`;
        }
    }

    return null; // All checks passed, no errors
}

  getCityData(address: any) {
    this.cityLatitude = address.geometry.location.lat();
    this.cityLongtitude = address.geometry.location.lng();
    if (address.address_components.length == 3) {
      this.vehicleState = address.address_components[1].long_name;
      this.vehicleCity = address.address_components[0].long_name;
    } else if (address.address_components.length == 4) {
      this.vehicleState = address.address_components[2].long_name;
      this.vehicleCity = address.address_components[1].long_name;
    } else if (address.address_components.length == 5) {
      this.vehicleState = address.address_components[3].long_name;
      this.vehicleCity = address.address_components[1].long_name;
    } else if (address.address_components.length == 6) {
      this.vehicleState = address.address_components[3].long_name;
      this.vehicleCity = address.address_components[2].long_name;
    }
    this.cityLatitude = address.geometry.location.lat();
    this.cityLongtitude = address.geometry.location.lng();
  }

  // Select image code start
  isValidImage: any;
  imageUrl = "";
  isImageUploaded = false;
  getVehicleImage(event) {
    if (
      event.target.files[0].type == "image/jpeg" ||
      event.target.files[0].type == "image/jpg" ||
      event.target.files[0].type == "image/png"
    ) {
      this.isValidImage = false;
      this.addvehicelService
        .addImage(event.target.files[0])
        .subscribe((result: any) => {
          console.log(result);
          if (result.statusCode == 200) {
            this.isImageUploaded = true;
            this.imageUrl = result.photoUrl;
          } else {
            this.isImageUploaded = false;
            this.imageUrl = "";
          }
          this.isValidImage = false;
        });
    } else {
      this.isValidImage = true;
      this.isImageUploaded = false;
    }
  }

  insuranceIsValidImage: any;
  insuranceImageUrl = "";
  insuranceIsImageUploaded = false;
  getInsuranceImage(event) {
    if (
      event.target.files[0].type == "image/jpeg" ||
      event.target.files[0].type == "image/jpg" ||
      event.target.files[0].type == "image/png"
    ) {
      this.insuranceIsValidImage = false;
      this.addvehicelService
        .addImage(event.target.files[0])
        .subscribe((result: any) => {
          console.log(result);
          if (result.statusCode == 200) {
            this.insuranceIsImageUploaded = true;
            this.insuranceImageUrl = result.photoUrl;
          } else {
            this.insuranceIsImageUploaded = false;
            this.insuranceImageUrl = "";
          }
          this.insuranceIsValidImage = false;
        });
    } else {
      this.insuranceIsValidImage = true;
      this.insuranceIsImageUploaded = false;
    }
  }

  rcIsValidImage: any;
  rcImageUrl = "";
  rcIsImageUploaded = false;
  getRcImage(event) {
    if (
      event.target.files[0].type == "image/jpeg" ||
      event.target.files[0].type == "image/jpg" ||
      event.target.files[0].type == "image/png"
    ) {
      this.rcIsValidImage = false;
      this.addvehicelService
        .addImage(event.target.files[0])
        .subscribe((result: any) => {
          console.log(result);
          if (result.statusCode == 200) {
            this.rcIsImageUploaded = true;
            this.rcImageUrl = result.photoUrl;
          } else {
            this.rcIsImageUploaded = false;
            this.rcImageUrl = "";
          }
          this.rcIsValidImage = false;
        });
    } else {
      this.rcIsValidImage = true;
      this.insuranceIsImageUploaded = false;
    }
  }

  roadtaxIsValidImage: any;
  roadtaxImageUrl = "";
  roadtaxIsImageUploaded = false;
  getRoadTaxImage(event) {
    if (
      event.target.files[0].type == "image/jpeg" ||
      event.target.files[0].type == "image/jpg" ||
      event.target.files[0].type == "image/png"
    ) {
      this.roadtaxIsValidImage = false;
      this.addvehicelService
        .addImage(event.target.files[0])
        .subscribe((result: any) => {
          console.log(result);
          if (result.statusCode == 200) {
            this.roadtaxIsImageUploaded = true;
            this.roadtaxImageUrl = result.photoUrl;
          } else {
            this.roadtaxIsImageUploaded = false;
            this.roadtaxImageUrl = "";
          }
          this.roadtaxIsValidImage = false;
        });
    } else {
      this.roadtaxIsValidImage = true;
      this.insuranceIsImageUploaded = false;
    }
  }

  openAddVehicleModal(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  exportToExcel() {
    /* pass here the table id */
    let element = document.getElementById("excel-table");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, "Vehicle Report.xlsx");
  }

  labourAvail(value) {
    this.labourAvailable = value;
  }

  sharingModeStatus(value) {
    this.sharingMode = value;
  }

  routeViewDetails(data) {
    this.router.navigate(["dashboard/viewVehicleDetails"], {
      queryParams: { id: data._id },
    });
  }
}
